import { PurchasedWithMultipleProductsBuilder, Recommender, conditionBuilder } from "@relewise/client";
import fillSmallProduct from "./fillSmallProduct";
import { getUser } from "./utils";
const RELEWISE_DATASET_ID = relewiseData.relewise_dataset_id;
const RELEWISE_API_KEY = relewiseData.relewise_api_key;
const RELEWISE_SERVER_URL = relewiseData.relewise_server_url;
let recommender = false;

if (RELEWISE_API_KEY && RELEWISE_DATASET_ID && RELEWISE_SERVER_URL) {
  recommender = new Recommender(RELEWISE_DATASET_ID, RELEWISE_API_KEY, {
    serverUrl: RELEWISE_SERVER_URL,
  });
}

if (!customElements.get('relewise-cart-recommendations') && recommender) {
  class RelewiseCartRecommendations extends HTMLElement {
    readConfig() {
      this.displayedAt = "powerstep";
      this.resultAmount = this.classList.contains('desktop-recommendations') ? 6 : 4;
      this.currency = relewiseData.current_currency;
      this.productCardTemplate = this.querySelector('#cart-recommendations-product-template');
      this.productsInCart = this.getAttribute('data-products-in-cart')
        ? JSON.parse(this.getAttribute('data-products-in-cart').replace(/'/g, '"').replace(/(\w+):/g, '"$1":'))
        : [];
      this.productTypes = this.getAttribute('data-product-types-in-cart')
        ? this.getAttribute('data-product-types-in-cart').split(',').filter(type => type.trim() !== '')
        : [];
      const remainingForFreeShipping = document.querySelector('.cart-drawer_progress-bar')?.getAttribute('data-remaining-money');
      const baseOnFreeShipping = this.getAttribute('data-base-on-free-shipping');
      if (baseOnFreeShipping) {
        this.priceMinimum = remainingForFreeShipping > 1 ? parseInt(remainingForFreeShipping) : 0;
        this.priceMaximum = remainingForFreeShipping > 1 ? this.priceMinimum + 100 : 500;
      } else {
        this.priceMinimum = 0;
        this.priceMaximum = 99999;
      }
    }

    render(recommendations) {
      if (!recommendations?.length) {
        this.remove();
        return;
      }
      if (!this.productCardTemplate) return;

      // Render is called both on the initial fetch and again whenever the cart
      // drawer content is replaced (which re-parses the mobile element from
      // server HTML). Clear any cards a previous render appended so re-renders
      // on a freshly-replaced element are idempotent and don't duplicate.
      this.querySelectorAll('.product-list').forEach((card) => card.remove());

      recommendations.slice(0, this.resultAmount).forEach((product) => {
        const productCard = fillSmallProduct(product, this.productCardTemplate, this.currency);
        if (!productCard) return;
        const img = productCard.querySelector('img');
        if (img) img.src += img.src.includes('?') ? '&width=100' : '?width=100';
        this.appendChild(productCard);
      });
      this.activateAddToCartLoadAnimation();
    }

    activateAddToCartLoadAnimation() {
      const addToCartButtons = this.querySelectorAll('.product-cart-item .suggestions-addtocart');
      addToCartButtons.forEach((button) => {
        button.addEventListener('click', function () {
          button.classList.add('loading');
        });
      });
    }
  }

  customElements.define('relewise-cart-recommendations', RelewiseCartRecommendations);

  const cartDrawer = document.querySelector('[data-component-id="cart-drawer"]');
  if (cartDrawer) {
    // Cache the Relewise response for the lifetime of the page so we only ever
    // make a single request per cart load. Mobile and desktop both render from
    // this shared cache.
    let cachedRecommendations = null;
    let fetchPromise = null;

    const fillAllElements = () => {
      const elements = [...document.querySelectorAll('relewise-cart-recommendations')];
      if (!elements.length) return;
      elements.forEach((el) => {
        el.readConfig();
        el.render(cachedRecommendations);
      });
    };

    cartDrawer.addEventListener('drawer-opened', async () => {
      const elements = [...document.querySelectorAll('relewise-cart-recommendations')];
      if (!elements.length) return;

      elements.forEach((el) => el.readConfig());

      // Use the desktop element as the reference (highest result count); fall back to first
      const primary = elements.find((el) => el.classList.contains('desktop-recommendations')) || elements[0];

      if (!fetchPromise) {
        fetchPromise = (async () => {
          const user = await getUser();

          const settings = {
            language: 'da',
            currency: primary.currency,
            displayedAtLocation: primary.displayedAt,
            user,
          };

          let builder = new PurchasedWithMultipleProductsBuilder(settings)
            .setSelectedProductProperties({ displayName: true, pricing: true, allData: true, allVariants: true })
            .setSelectedVariantProperties({ displayName: true, pricing: true, allData: true })
            .addProducts(primary.productsInCart)
            .setNumberOfRecommendations(primary.resultAmount)
            .filters((f) => f.addProductSalesPriceFilter(primary.priceMinimum, primary.priceMaximum));

          primary.productTypes.forEach((productType) => {
            builder = builder.filters((f) => f.addProductDataFilter(
              'ProductType',
              (cb) => cb.addEqualsCondition(productType, true),
              true, true, true
            ));
          });

          try {
            const results = await recommender.recommendPurchasedWithMultipleProducts(builder.build());
            return results?.recommendations ?? null;
          } catch (err) {
            console.error('Relewise recommendations failed:', err);
            return null;
          }
        })();

        cachedRecommendations = await fetchPromise;
      } else {
        // Another open is already (or has already) fetched — wait for it.
        await fetchPromise;
      }

      fillAllElements();
    });

    // When replaceCartContent runs (after add-to-cart or quantity update) the
    // mobile recommendations element lives inside .drawer-content-wrapper and
    // gets re-parsed from server HTML, losing its rendered cards. Re-render the
    // cached recommendations into it so mobile stays in sync with desktop
    // without making another Relewise request. The desktop element is outside
    // the wrapper so it is unaffected — but rendering is idempotent so
    // re-running it is safe.
    document.addEventListener('cart:updated', () => {
      if (!cachedRecommendations) return;
      fillAllElements();
    });
  }
}

document.querySelector('.close-recommendations')?.addEventListener('click', () => {
  const cartDrawerElement = document.querySelector('.cart-drawer-element');
  if (!cartDrawerElement) return;

  const recommendationsDrawer = cartDrawerElement.querySelector('.recommendations-drawer');

  if (recommendationsDrawer) {
    recommendationsDrawer.classList.add('hidden');
  }

  cartDrawerElement.style.setProperty('max-width', '420px', 'important');

  const recommendationsButton = cartDrawerElement.querySelector('.show-recommendations');
  recommendationsButton.classList.remove('hidden');

  document.querySelector('.show-recommendations')?.addEventListener('click', () => {
    console.log('kliknuto dugme');
    const cartDrawerElement = document.querySelector('.cart-drawer-element');
    if (!cartDrawerElement) return;

    const recommendationsDrawer = cartDrawerElement.querySelector('.recommendations-drawer');

    if (recommendationsDrawer) {
      recommendationsDrawer.classList.remove('hidden');
    }

    cartDrawerElement.style.setProperty('max-width', '790px', 'important');

    const recommendationsButton = cartDrawerElement.querySelector('.show-recommendations');
    recommendationsButton.classList.add('hidden');
  });

});

document.addEventListener('mousedown', (e) => {
  const select = e.target.closest('.desktop-recommendations .self-start select');
  if (select) {
    select.classList.add('select-open');
  }
});

document.addEventListener('blur', (e) => {
  const select = e.target.closest('.desktop-recommendations .self-start select');
  if (select) {
    select.classList.remove('select-open');
  }
}, true);